// extracted by mini-css-extract-plugin
export var blink = "_9r-2";
export var cursor = "_9r-1";
export var reactMarkdown = "_9r-3";
export var streamingText = "_9r-0";